var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseOutlined(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 51 51)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d70000",
    d: "M26.682 29.864c-.91-.864-.91-2.273 0-3.182.91-.91 2.318-.91 3.182 0L51 47.818l21.136-21.136c.864-.91 2.273-.91 3.182 0 .91.91.91 2.318 0 3.182L54.182 51l21.136 21.136c.91.864.91 2.273 0 3.182a2.244 2.244 0 0 1-1.59.682 2.244 2.244 0 0 1-1.592-.682L51 54.182 29.864 75.318a2.244 2.244 0 0 1-1.591.682 2.244 2.244 0 0 1-1.59-.682c-.91-.91-.91-2.318 0-3.182L47.817 51 26.682 29.864zM50.5 97C76.132 97 97 76.132 97 50.5S76.132 4 50.5 4 4 24.868 4 50.5 24.868 97 50.5 97zM51 0c28.107 0 51 22.893 51 51s-22.893 51-51 51S0 79.107 0 51 22.893 0 51 0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseOutlined);
export default __webpack_public_path__ + "static/media/closeOutlined.dd643d62a0230d47f7eaae0ab8a03629.svg";
export { ForwardRef as ReactComponent };